<template>
  <div class="wh-select-popup" @click="visible=true">
    {{ text }}
    <van-icon name="arrow-down" />
    <van-popup v-model="visible" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="options"
        @confirm="onConfirm"
        @cancel="visible = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'WhSelectPopup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    text() {
      const val = (this.options.find(i => {
        if (i.constructor === String || i.constructor === Number) {
          return i === this.value
        } else if (i.constructor === Object) {
          return i.value === this.value
        }
      })) || this.placeholder
      if (val.constructor === Object) {
        return val.text
      } else {
        return val
      }
    }
  },
  methods: {
    onConfirm(val, index) {
      if (val.constructor === Object) {
        this.$emit('change', val.value)
      } else {
        this.$emit('change', val)
      }
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.wh-select-popup {
  display: inline-block;
  padding: 0 12px;
  font-size: 12px;
  line-height: 28px;
  color: #323332;
  border: 1px solid #EFEFEF;
  border-radius: 2px;
}
</style>
